export const environment = {
  production: true,
  apiUrl: 'https://api.mentoga.com/',
  // apiUrl: 'https://localhost:44392/',
  imageUrl: 'https://api.mentoga.com',
  mentorZoomAuthUrl:
    'https://zoom.us/oauth/authorize?client_id=RqrpOOJbTXKvKW9bWjcacA&response_type=code&redirect_uri=https://api.mentoga.com/api/zoom/setupMentorZoomToken/',
  Calender365Url:
    'https://login.microsoftonline.com/common/oauth2/v2.0/authorize?scope=Calendars.ReadWrite offline_access User.Read&response_type=code&response_mode=query&redirect_uri=https://api.mentoga.com/api/extauth/microsoft-authorize&client_id=b9c4fa8a-9f8c-4449-bf7e-18bdee0157be&state=',
  GoogleCalenderUrl: 'https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/calendar&prompt=consent&access_type=offline&include_granted_scopes=true&response_type=code&redirect_uri=https://api.mentoga.com/api/extauth/google-authorize&client_id=157130447797-l4guol83pf70fbefafrebjrmtqfjcc89.apps.googleusercontent.com&state=',
  googleAuthKey:
    '1079024630020-ofve7g2hgifbblest32poc12j699sjg0.apps.googleusercontent.com',
  facebookAuthKey: '580847790086880',
  pagePlaceholder: `[CreatorName]`,
  pwaUrl: 'https://mentoga.com/',
  zoomSDKKey: 'Ark4XMVXQOvHVKLXjWY7xDP3dy9w8XWD89ss',
  zoomSDKSecret: 'Shxjd1FQhYyotxfKpZTQepjOizE91mMkUtwV',
  sentryDsn: "https://b130c35c3089180177bffbc5d06de4cf@o4508438011379712.ingest.us.sentry.io/4508438014722048",
  appVersion: '2025.06.02.1.0',
};